/* eslint-disable no-unused-vars */
export enum ConfigActionType {
  GET_CONFIG = 'get_config',
  GET_CONFIG_SUCCESS = 'get_config_success',
  GET_CONFIG_FAILURE = 'get_config_failure',

  PATCH_CONFIG_SUCCESS = 'patch_config_success',
  PATCH_CONFIG_FAILURE = 'patch_config_failure',
}
